import { ResourceItem } from 'sos-common/js/commonTypes';

function _translate(
  _translations: ResourceItem[],
  key: string,
  defaultValue?: string
) {
  if (!_translations.length) {
    console.error('No translations');
    return '';
  }
  const keyCleaned = key.replace('/', '\/');
  const re = new RegExp(keyCleaned, 'ig');
  const query = _translations.filter(t => t.Key.match(re));
  if (!query.length) {
    console.warn(`No translation matching key: ${key} could be found`);
    return defaultValue || '';
  }
  return query[0].Value;
}

export type translateFunc = ReturnType<typeof makeTranslator>; 

export function makeTranslator(translations: ResourceItem[]) {
  return function (key: string, defaultValue?: string) {
    return _translate(translations, key, defaultValue);
  };
}
